import { secured } from '@/plugins/axios';

const resource = '/suggestions/admin';

export default {
    getSuggestionGroups: () => secured.get(`${resource}/suggestion-groups/`),
    createSuggestionGroup: payload => secured.post(`${resource}/suggestion-groups/`, payload),
    updateSuggestionGroup: (id, payload) => secured.put(`${resource}/suggestion-groups/${id}/`, payload),
    deleteSuggestionGroup: id => secured.delete(`${resource}/suggestion-groups/${id}/`),
    activateSuggestionGroup: id => secured.post(`${resource}/suggestion-groups/${id}/activate-group/`),
};
